import { API_BASE_URL } from "@/api/api.config";
import useRestQuery from "@/remoteState/useRestQuery";
import getDistrictUUID from "@/utils/getDistrictUUID";
import useUser from "@/users/useUser";

export const DEFAULT_MESSAGE_BODY =
  "Your admin has flagged this content with an advisory label. It may be in violation of district policies or curricular goals. Please contact your admin for more information.";
export const DEFAULT_MESSAGE_TITLE = "Important message";
export const CUSTOM_MESSAGE_TITLE = "A message from your district";
export const HYPERLINK_TEXT = "Learn more";
/**
 * This function was extracted from the hook to be able to validate the business logic
 * in unit tests.
 *
 * It is not expected to use this function outside this scope.
 * */
export const _determineAdvisoryMessage = ({
  data: advisoryMessage,
  error,
  loading,
}) => {
  let data;

  if (loading) data = { body: null, title: null, hyperlink: null };
  else if (advisoryMessage && advisoryMessage?.date_archived === null) {
    data = {
      body: advisoryMessage?.text,
      title: CUSTOM_MESSAGE_TITLE,
      hyperlink: {
        url: advisoryMessage?.url,
        text: HYPERLINK_TEXT,
      },
    };
  } else {
    data = {
      body: DEFAULT_MESSAGE_BODY,
      title: DEFAULT_MESSAGE_TITLE,
      hyperlink: null,
    };
  }
  return { data, loading, error };
};
/**
 * Get advisory message given the district. If a custom message is configured it is going
 * to return that message. Otherwise it is going to return the default message.
 *
 * @param {(string)} districtId Id of a district.
 * @returns {{data: Object, error: Error, loading: boolean}} Info about the query state.
 */
const useAdvisoryMessageGet = () => {
  const { data: user } = useUser();
  const districtId = getDistrictUUID(user);
  const requestUrl = `${API_BASE_URL}/api/v2/district/${districtId}/content-advisory-configuration/`;
  const response = useRestQuery(requestUrl);

  return _determineAdvisoryMessage(response);
};

export default useAdvisoryMessageGet;
